<template>
  <div>
  	<router-view></router-view>
    <BottomSheet></BottomSheet>
  </div>
</template>

<script>
import List from './monitor/List'
import ChannelEditor from '@/components/channels/Editor'
import BottomSheet from './BottomSheet'

export default {
  routes: [
    {
      path: "",
      redirect: "/monitor/list"
    },
    {
      path: "list",
      component: List,
      name: "Monitor list",
      meta: {search: false},
    },
    {
      path: "channel/:id",
      name: "Monitor edit channel",
      components: {
        default: List,
        bottomEditor: ChannelEditor
      },
      props: {
        default: false,
        bottomEditor: true
      },
      meta: {
        new: "New event",
        search: false

      }
    }
  ],
  components: {
    BottomSheet
  }
}
</script>
